import { render, staticRenderFns } from "./CadastroFilaAutorizacao.vue?vue&type=template&id=2a1cfe78&"
import script from "./CadastroFilaAutorizacao.vue?vue&type=script&lang=js&"
export * from "./CadastroFilaAutorizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports